import React, { useState } from 'react';
import { httpsCallable, getFunctions } from 'firebase/functions';
import { useAuth } from '../../contexts/AuthContext';

// Run only from admin-authenticated route. Server also verifies Firestore /users/{uid}.role.
export default function WorkOrderNumberMigration(){
  const {userProfile}=useAuth();
  const [cursor,setCursor]=useState('');
  const [processed,setProcessed]=useState(0);
  const [running,setRunning]=useState(false);
  const [done,setDone]=useState(false);
  const [error,setError]=useState('');
  if(userProfile?.role!=='admin') return <p>Administrator access required.</p>;
  async function processNext(){
    setRunning(true);setError('');
    try{
      const response=await httpsCallable(getFunctions(),'backfillWorkOrderNumbers')({after:cursor});
      setCursor(response.data.nextCursor||cursor);
      setProcessed(n=>n+Number(response.data.processed||0));
      setDone(response.data.done===true);
    }catch(err){console.error('Work-order backfill failed',err);setError(err.message||'Unable to run migration');}
    finally{setRunning(false);}
  }
  return <div className="max-w-2xl mx-auto p-6 sm:p-10"><div className="bg-white border border-slate-200 rounded-xl p-6 sm:p-8 space-y-4"><p className="text-xs uppercase font-semibold tracking-widest text-[#2f79d4]">Admin tools</p><h1 className="text-2xl font-semibold">Work order reference migration</h1><p className="text-sm text-slate-600">Safely assign B0T + five-digit references to existing work orders, 12 at a time. Does not change payment, quote or report details. All allocated numbers remain permanently reserved, even if an order is deleted.</p><p className="text-sm"><strong>{processed}</strong> work orders scanned this session</p>
    {done ? <p role="status" className="text-emerald-700 font-semibold">Migration complete.</p> : <button type="button" onClick={processNext} disabled={running} className="bg-[#142235] hover:bg-[#243a56] text-white px-5 min-h-12 rounded-lg font-semibold disabled:opacity-60">{running?'Processing…':processed?'Process next 12':'Start migration'}</button>}
    {error&&<p role="alert" className="text-red-700">{error}</p>}
    <p className="text-xs text-slate-500">Keep this tab open while processing. If interrupted, repeat from the beginning; processed orders keep the same number.</p></div></div>;
}
